import { useEffect } from "react";
import LoadingSpinner from "../LoadingSpinner";
import avatar from "../../assets/svg/avatar.svg";

export default function UserProfilePictureAvatar({
  profilePictureUrl,
  className,
  loading = false,
  alt = "Profile Picture",
  onClick,
}: {
  profilePictureUrl: string | null | undefined;
  className?: string;
  loading?: boolean;
  size?: number;
  alt?: string;
  onClick?: () => void;
}) {
  if (loading) {
    return <LoadingSpinner size={64} />;
  }

  return (
    <img
      src={profilePictureUrl || avatar}
      className={`rounded-full overflow-hidden object-cover bg-gray-100 text-brandblue-500 text-sm ${
        className ? className : "h-16 w-16"
      }`}
      alt={alt}
      key={profilePictureUrl}
      onClick={onClick}
    />
  );
}
